import Breadcumbs from "../components/Breadcumbs";
import DataFetcherTemplate from "../hooks/fetchTemplate";
import { NavLink } from "react-router-dom";

import BlockLeftImage from "../components/BlockLeftImage";
import DataTable from "react-data-table-component";
import Accordion from "../components/Accordion";
import DataFetcherNews from "../hooks/fetchNews";
import { motion } from "framer-motion";

import caces from "../img/logoscalidad/caces-svg.png";
import acreditae from "../img/logoscalidad/acreditae.jpg";
import chile from "../img/logoscalidad/chile.jpg";
import equa from "../img/logoscalidad/equa.png";
import kalos from "../img/logoscalidad/kalos.jpeg";
import the from "../img/logoscalidad/the.png";

import certificacion1 from "../img/logoscalidad/certificacion1.png";
import certificacion2 from "../img/logoscalidad/certificacion1.png";

import autoevaluacion from "../img/logoscalidad/autoevaluacion.png";

const columns1 = [
  {
    name: "Agencia",
    selector: (row) => row.agencia,
    sortable: true,
    wrap: true,
  },
  {
    name: "Fecha de acreditación",
    selector: (row) => row.year,
    sortable: true,
    maxWidth: "200px",
  },
  {
    name: "Denominación",
    selector: (row) => row.denominacion,
    sortable: true,
    maxWidth: "150px",
  },
  {
    name: "Duración",
    selector: (row) => row.duracion,
    sortable: true,
    maxWidth: "120px",
  },
  {
    name: "Estado",
    selector: (row) => row.estado,
    sortable: true,
    maxWidth: "120px",
  },
];

const columns2 = [
  {
    name: "Facultad / Unidad Académica",
    selector: (row) => row.facultad,
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Carrera",
    selector: (row) => row.carrera,
    sortable: true,
    minWidth: "120px",
    wrap: true,
  },
  {
    name: "Modalidad",
    selector: (row) => row.modalidad,
    sortable: true,
    maxWidth: "100px",
    wrap: true,
  },
  {
    name: "Agencia",
    selector: (row) => row.agencia,
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "País",
    selector: (row) => row.pais,
    sortable: true,
    maxWidth: "100px",
    wrap: true,
  },

  {
    name: "Fecha",
    selector: (row) => row.fecha,
    sortable: true,
    minWidth: "100px",
    wrap: true,
  },
  {
    name: "Denominación",
    selector: (row) => row.denominacion,
    sortable: true,
    maxWidth: "120px",
    wrap: true,
  },
  {
    name: "Alcance",
    selector: (row) => row.alcance,
    sortable: true,
    minWidth: "120px",
    wrap: true,
  },
  {
    name: "Duración",
    selector: (row) => row.duracion,
    sortable: true,
    maxWidth: "90px",
    wrap: true,
  },
  {
    name: "Estado",
    selector: (row) => row.estado,
    sortable: true,
    maxWidth: "90px",
    wrap: true,
  },
];
const columns3 = [
  {
    name: "Facultad / Unidad Académica",
    selector: (row) => row.facultad,
    sortable: true,
    wrap: true,
  },
  {
    name: "Posgrado",
    selector: (row) => row.posgrado,
    sortable: true,
    wrap: true,
  },
  {
    name: "Modalidad",
    selector: (row) => row.modalidad,
    sortable: true,
    maxWidth: "150px",
  },
  {
    name: "Agencia",
    selector: (row) => row.agencia,
    sortable: true,

    wrap: true,
  },
  {
    name: "País",
    selector: (row) => row.pais,
    sortable: true,
    maxWidth: "120px",
  },
  {
    name: "Alcance",
    selector: (row) => row.alcance,
    sortable: true,
    maxWidth: "120px",
  },
  {
    name: "Estado",
    selector: (row) => row.estado,
    sortable: true,
    maxWidth: "120px",
  },
  {
    name: "Duración",
    selector: (row) => row.duracion,
    sortable: true,
    maxWidth: "100px",
  },
];

const datatable1 = [
  {
    id: 2,
    agencia:
      "Consejo de Aseguramiento de la Calidad de la Educación Superior - CACES",
    year: "25 de octubre de 2020",
    denominacion: "Acreditada",
    duracion: "5 años",
    estado: "Vigente",
  },
];

const datatable2 = [
  {
    id: 1,
    facultad: "Facultad Ciencias de la Salud ",
    carrera: "Enfermería",
    modalidad: "Presencial",
    agencia: "Agencia Acreditadora de Chile Acreditación y Calidad",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    fecha: "Julio 2025",
    denominacion: "Acreditada",
    alcance: "Internacional",
    duracion: "6 años",
    estado: "Vigente",
  },

  {
    id: 2,
    facultad: "Facultad Ciencias de la Salud ",
    carrera: "Enfermería",
    modalidad: "Presencial",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),

    fecha: "",
    denominacion: "Acreditada",
    alcance: "Nacional",
    duracion: "6 años",
    estado: "Vigente",
  },

  {
    id: 3,
    facultad: "Facultad Ciencias de la Salud ",
    carrera: "Medicina",
    modalidad: "Presencial",
    agencia: "Acreditae",
    pais: (
      <>
        España{" "}
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/espania.png"></img>
      </>
    ),

    fecha: "Septiembre 2024",
    denominacion: "Certificación",
    alcance: "Internacional",
    duracion: "4 años",
    estado: "Vigente",
  },
  {
    id: 4,
    facultad: "Facultad de Ciencias Jurídicas y Políticas",
    carrera: "Derecho",
    modalidad: "A distancia",
    agencia: "Sello de Calidad Kalos Virtual Iberoamérica",
    pais: (
      <>
        México{" "}
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/mexico.png"></img>
      </>
    ),

    fecha: "Septiembre 2022",
    denominacion: "Acreditada",
    alcance: "Internacional",
    duracion: "6 años",
    estado: "Vigente",
  },
  {
    id: 5,
    facultad: "Facultad de Ciencias Jurídicas y Políticas",
    carrera: "Derecho",
    modalidad: "A distancia",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),
    fecha: "Agosto 2022",
    denominacion: "Acreditada",
    alcance: "Nacional",
    duracion: "5 años",
    estado: "Vigente",
  },
  {
    id: 6,
    facultad: "Facultad de Ciencias Jurídicas y Políticas",
    carrera: "Derecho",
    modalidad: "Presencial",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),
    fecha: "Febrero 2018",
    denominacion: "Acreditada",
    alcance: "Nacional",
    duracion: "5 años",
    estado: "Vigente",
  },

  {
    id: 7,
    facultad: "Facultad de Ciencias Exactas y Naturales",
    carrera: "Ingeniería Química",
    modalidad: "Presencial",
    agencia: "Agencia Acreditadora de Chile Acreditación y Calidad",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    fecha: "Marzo 2021",
    denominacion: "Acreditada",
    alcance: "Internacional",
    duracion: "5 años",
    estado: "Vigente",
  },
  {
    id: 8,
    facultad: "Facultad de Ciencias Exactas y Naturales",
    carrera: "Ingeniería Química",
    modalidad: "Presencial",
    agencia: "Consejo de Aseguramiento de la Calidad de Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),
    fecha: "Marzo 2021",
    denominacion: "Acreditada",
    alcance: "Nacional",
    duracion: "5 años",
    estado: "Vigente",
  },
  {
    id: 9,
    facultad: "Facultad de Ciencias Exactas y Naturales",
    carrera: "Bioquímica y Farmacia",
    modalidad: "Presencial",
    agencia: "Agencia Acreditadora de Chile Acreditación y Calidad",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    fecha: "Marzo 2021",
    denominacion: "Acreditada",
    alcance: "Internacional",
    duracion: "5 años",
    estado: "Vigente",
  },
  {
    id: 10,
    facultad: "Facultad de Ciencias Exactas y Naturales",
    carrera: "Bioquímica y Farmacia",
    modalidad: "Presencial",
    agencia: "Consejo de Aseguramiento de la Calidad de Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),
    fecha: "Marzo 2021",
    denominacion: "Acreditada",
    alcance: "Nacional",
    duracion: "5 años",
    estado: "Vigente",
  },
  {
    id: 11,
    facultad: "Facultad de Ciencias Exactas y Naturales",
    carrera: "Ingeniero en Alimentos",
    modalidad: "Presencial",
    agencia: "Agencia Acreditadora de Chile Acreditación y Calidad",
    pais: (
      <>
        Chile{" "}
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    fecha: "Marzo 2021",
    denominacion: "Acreditada",
    alcance: "Internacional",
    duracion: "5 años",
    estado: "Vigente",
  },
  {
    id: 12,
    facultad: "Facultad de Ciencias Exactas y Naturales",
    carrera: "Ingeniero en Alimentos",
    modalidad: "Presencial",
    agencia: "Consejo de Aseguramiento de la Calidad de Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),
    fecha: "Marzo 2021",
    denominacion: "Acreditada",
    alcance: "Nacional",
    duracion: "5 años",
    estado: "Vigente",
  },
  {
    id: 13,
    facultad: "Facultad de Ciencias de la Salud",
    carrera: "Medicina",
    modalidad: "Presencial",
    agencia: "Consejo de Aseguramiento de la Calidad de Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),
    fecha: "Octubre 2019",
    denominacion: "Acreditada",
    alcance: "Nacional",
    duracion: "5 años",
    estado: "Vigente",
  },
];

const datatable3 = [
  {
    id: 1,
    facultad: "Facultad de Ciencias de la Salud",
    posgrado: "Gerencia de Instituciones de Salud",
    modalidad: "En línea",
    agencia: "Agencia Acreditadora de Chile Acreditación & Calidad ",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    alcance: "Internacional",
    estado: "Acreditada",
    duracion: "5 años",
  },

  {
    id: 2,
    facultad: "Facultad de Ciencias de la Salud",
    posgrado: "Gerencia de Instituciones de Salud",
    modalidad: "En línea",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior ",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),

    alcance: "Nacional",
    estado: "Acreditada",
    duracion: "5 años",
  },

  {
    id: 3,
    facultad: "Facultad de Ciencias de la Salud",
    posgrado: "Gestión de la Calidad y Auditoría en Salud",
    modalidad: "En línea",
    agencia: "Agencia Acreditadora de Chile Acreditación & Calidad ",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    alcance: "Internacional",
    estado: "Acreditada",
    duracion: "5 años",
  },

  {
    id: 4,
    facultad: "Facultad de Ciencias de la Salud",
    posgrado: "Gestión de la Calidad y Auditoría en Salud",
    modalidad: "En línea",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior ",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),

    alcance: "Nacional",
    estado: "Acreditada",
    duracion: "5 años",
  },

  {
    id: 5,
    facultad: "Facultad de Ciencias de la Salud",
    posgrado: "Análisis Biológico y Diagnóstico de Laboratorio",
    modalidad: "Presencial",
    agencia: "Agencia Acreditadora de Chile Acreditación & Calidad ",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    alcance: "Internacional",
    estado: "Acreditada",
    duracion: "6 años",
  },

  {
    id: 6,
    facultad: "Facultad de Ciencias de la Salud",
    posgrado: "Análisis Biológico y Diagnóstico de Laboratorio",
    modalidad: "Presencial",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),

    alcance: "Nacional",
    estado: "Acreditada",
    duracion: "6 años",
  },

  {
    id: 7,
    facultad: "Facultad de Ciencias Jurídicas y Políticas",
    posgrado: "Derecho, mención Derecho Procesal",
    modalidad: "En línea",
    agencia: "Agencia Acreditadora de Chile Acreditación & Calidad ",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    alcance: "Internacional",
    estado: "Acreditada",
    duracion: "6 años",
  },
  {
    id: 8,
    facultad: "Facultad de Ciencias Jurídicas y Políticas",
    posgrado: "Derecho, mención Derecho Procesal",
    modalidad: "En línea",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior ",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),

    alcance: "Nacional",
    estado: "Acreditada",
    duracion: "6 años",
  },
  {
    id: 9,
    facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
    posgrado: "Educación, mención Innovación y Liderazgo Educativo",
    modalidad: "En línea",
    agencia: "Agencia Acreditadora de Chile Acreditación & Calidad ",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    alcance: "Internacional",
    estado: "Acreditada",
    duracion: "8 años",
  },

  {
    id: 10,
    facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
    posgrado: "Educación, mención Innovación y Liderazgo Educativo",
    modalidad: "En línea",
    agencia:
      "Consejo de Aseguramiento de la Calidad de la Educación Superior Ecuador",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),

    alcance: "Nacional",
    estado: "Acreditada",
    duracion: "8 años",
  },

  {
    id: 11,
    facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
    posgrado: "Educación, mención Enseñanza de la Matemática",
    modalidad: "En línea",
    agencia: "Agencia Acreditadora de Chile Acreditación & Calidad ",
    pais: (
      <>
        Chile
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/chile.png"></img>
      </>
    ),

    alcance: "Internacional",
    estado: "Acreditada",
    duracion: "8 años",
  },

  {
    id: 12,
    facultad: "Facultad de Ciencias Sociales, Educación y Humanidades",
    posgrado: "Educación, mención Enseñanza de la Matemática",
    modalidad: "En línea",
    agencia: "Consejo de Aseguramiento de la Calidad de la Educación Superior",
    pais: (
      <>
        Ecuador
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/ecuador.png"></img>
      </>
    ),

    alcance: "Nacional",
    estado: "Acreditada",
    duracion: "8 años",
  },

  {
    id: 13,
    facultad: "Escuela de Desarrollo Empresarial y Social",
    posgrado: "Administración de Empresas, mención Innovación",
    modalidad: "Presencial, En línea",
    agencia: "Education Quality Accreditation Agency",
    pais: (
      <>
        Perú
        <img src="https://eventos.utpl.edu.ec/sites/default/files/images/peru.png"></img>
      </>
    ),
    alcance: "Internacional",
    estado: "En proceso",
  },
];

function Calidad() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <div className="margin">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/transparencia">Transparencia</NavLink>
                    <span class="material-icons">chevron_right</span>
                    <NavLink to="/calidad">Calidad</NavLink>
                  </>
                }
              ></Breadcumbs>
            </div>
            <BlockLeftImage
              src={item.field_imagen1}
              content={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                  <a className="button1" href="#posicionamiento">
                    <span class="material-icons">chevron_right</span>{" "}
                    Posicionamiento institucional
                  </a>
                  <a className="button1" href="#evaluacion">
                    <span class="material-icons">chevron_right</span> Evaluación
                    y acreditación nacional e internacional
                  </a>

                  <br></br>
                  <Accordion
                    title="Documentos institucionales"
                    content={
                      <>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque2,
                          }}
                        />
                      </>
                    }
                  ></Accordion>
                </>
              }
            ></BlockLeftImage>
            <div className="lightbluebg padding">
              <div className=" layout8">
                <div className="icon50"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque7,
                  }}
                />
                <div className="flex-center icon300"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque8,
                  }}
                />
              </div>
            </div>

            <div id="posicionamiento" className=" graybg padding">
              <center>
                <div
                  className="layout8"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque3,
                  }}
                />
              </center>

              <DataFetcherNews url="https://noticias.utpl.edu.ec/parque/servicio-ranking.json" />

              <div>
                <div className="layout6 margin">
                  <center>
                    <h2>
                      UTPL, entre las{" "}
                      <b> 3 principales universidades en sostenibilidad</b>
                       según 
                    </h2>

                    <div className="icon300">
                      <img src={the}></img>
                    </div>
                    <br></br>
                    <iframe
                      src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Futploficial%2Fvideos%2F1309956844095138%2F&show_text=false&width=267&t=0"
                      width="267"
                      height="476"
                    ></iframe>
                  </center>
                </div>
              </div>

              <div className="layout8">
                <h4>
                  ¿Necesitas <b>más información?</b>
                </h4>
                <p>📩 dcolindres@utpl.edu.ec </p>
                <p> 📞 07 370 1444 ext. 2279</p>
                <p>Dora Colindres Lozano </p>
                <p>Coordinadora de Posicionamiento y Prestigio Institucional</p>
              </div>
            </div>
            <div className="padding" id="evaluacion">
              <center>
                {" "}
                <h2>
                  <b>Evaluación y acreditación</b> nacional e internacional
                </h2>
              </center>

              <center>
                <div className="icon200">
<img src={autoevaluacion}></img>
<br></br>
                </div>
              </center>

              <div className=" wrapper-evaluacion-institucional wrapper-evaluacion">
                <div className="layout8 icon100">
                  <motion.div
                    initial={{ y: 200, opacity: 0 }}
                    whileInView={{
                      y: 0,
                      opacity: 1,
                      transition: {
                        type: "spring",
                        stiffness: 200,
                      },
                    }}
                  >
                    <center>
                      <div className="width700 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque4,
                          }}
                        />
                      </div>
                    </center>
                  </motion.div>
                  <div className="table-calidad">
                    <DataTable columns={columns1} data={datatable1} />
                  </div>
                </div>
              </div>

              <div className=" padding2 wrapper-evaluacion">
                <div className="layout9">
                  <center>
                    <motion.div
                      initial={{ y: 200, opacity: 0 }}
                      whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                          type: "spring",
                          stiffness: 200,
                        },
                      }}
                    >
                      <div className="width700 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque5,
                          }}
                        />
                      </div>
                    </motion.div>
                  </center>
                  <div className="table-calidad">
                    <DataTable
                      columns={columns2}
                      data={datatable2}
                      pagination
                    />
                  </div>
                </div>
              </div>

              <div className="  wrapper-evaluacion">
                <div className="layout9">
                  <center>
                    <motion.div
                      initial={{ y: 200, opacity: 0 }}
                      whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                          type: "spring",
                          stiffness: 200,
                        },
                      }}
                    >
                      <div className="width700 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque6,
                          }}
                        />
                      </div>
                    </motion.div>
                  </center>
                  <div className="table-calidad">
                    <DataTable
                      columns={columns3}
                      data={datatable3}
                      pagination
                    />
                  </div>
                </div>
              </div>

              <div className="padding2">
                <div className="layout8 grayicon">
                  <center>
                    <h3>
                      Acreditadoras <b>nacionales</b>
                    </h3>
                    <div className="flex-center icon200">
                      <div>
                        <a
                          href="https://www.caces.gob.ec"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={caces}></img>
                        </a>
                      </div>
                    </div>

                    <h3>
                      Acreditadoras <b>internacionales</b>
                    </h3>
                    <div className="flex-center icon150">
                      <div>
                        <img src={chile}></img>
                      </div>

                      <div>
                        <img src={equa}></img>
                      </div>

                      <div>
                        <img src={kalos}></img>
                      </div>
                    </div>

                    <h3>
                      {" "}
                      Certificaciones <b>internacionales</b>
                    </h3>
                    <div className="flex-center icon150">
                      <div>
                        <img src={acreditae}></img>
                      </div>{" "}
                    </div>

                      <h3>
                      Cualificación  <b>académica</b>
                    </h3>
                      <div className="flex-center icon200">
                      <div>
                        <img src={certificacion1}></img>
                      </div>
                            <div>
                        <img src={certificacion2}></img>
                      </div>
                    </div>
                  </center>
                </div>
              </div>

              <div className="layout8">
                <h4>
                  ¿Necesitas <b>más información?</b>
                </h4>
                <p>📩 cglabanda@utpl.edu.ec</p>
                <p> 📞 07 370 1444 ext. 2237</p>
                <p>Cristhian German Labanda</p>
                <p>Especialista de Evaluación Institucional</p>
              </div>
            </div>
          </>
        ))}
      </>
    </>
  );

  return (
    <div>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-calidad.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </div>
  );
}

export default Calidad;
